import React from "react";
export const Stroke3 = (props) => {
    var _a;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size, height: props.size, viewBox: "0 0 10 7", fill: "none" },
        React.createElement("path", { d: "M1 3.5L3.66742 6L9 1", stroke: (_a = props.color) !== null && _a !== void 0 ? _a : "#00B894", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=Stroke3.js.map